import logoImage from './../assets/images/hcsc-logo.png';
import { CLIENT_NAME, CLIENT_THEME } from "../utils/constants";
import { getFormFields } from "../components/hcsc/fields";

const config = {
    clientName: CLIENT_NAME.HCSC,

    // theme
    theme: CLIENT_THEME.HCSC,

    // header
    logo: logoImage,
    logoWidth: 304,
    logoHeight: 'auto',
    logoLink: process.env.REACT_APP_PHARO_CONSUMER_CLIENT_RETURN_URL,

    // entry form
    entryForm: {
        title: 'ADVISORY GROUP - APPLICATION',
        showReturn: true,
        showCancel: true,
        customFields: {
            enabled: true,
            fieldGetter: getFormFields,
        },
    },

    tracking: {
        mail: "/?utm_source=mail&utm_medium=online&utm_campaign=recruit",
        mnews: "/?utm_source=mnews&utm_medium=online&utm_campaign=recruit",
        phcall: "/?utm_source=phcall&utm_medium=phone&utm_campaign=recruit",
        cs: "/?utm_source=cs&utm_medium=phone&utm_campaign=recruit",
        cm: "/?utm_source=cm&utm_medium=phone&utm_campaign=recruit",
        email: "/?utm_source=email&utm_medium=online&utm_campaign=recruit",
        enews: "/?utm_source=enews&utm_medium=online&utm_campaign=recruit",
        sms: "/?utm_source=sms&utm_medium=phone&utm_campaign=recruit",
        lp: "/?utm_source=lp&utm_medium=online&utm_campaign=recruit",
    },

    stateInfo: {
        nm: {
            logoName: 'hcsc-nm-logo.png',
            footer: {
                copyright: `Medicaid Plan Notice:Blue Cross and Blue Shield of New Mexico, a Division of Health Care Service Corporation, a Mutual Legal Reserve Company (HCSC), an Independent Licensee of the Blue Cross and Blue Shield Association.

Such services are funded in part with the State of New Mexico.

Medicare Advantage Plan Notice:HMO, PPO, HMO Special Needs Plans, and PPO Special Needs Plans provided by Health Care Service Corporation, a Mutual Legal Reserve Company (HCSC). PPO plan provided by HCSC Insurance Services Company (HISC). HCSC and HISC are Independent Licensees of the Blue Cross and Blue Shield Association. HCSC is a Medicare Advantage organization with a Medicare contract and a contract with the New Mexico Medicaid program. HISC is a Medicare Advantage organization with a Medicare contract. Enrollment in these plans depends on contract renewal.https://www.bcbsnm.com/legal-and-privacy/non-discrimination-notice`,
            },
        },
        ok: {
            logoName: 'hcsc-ok-logo.png',
            footer: {
                copyright: `HMO Special Needs Plan provided by GHS Insurance Company (GHSIC). GHSIC is an Independent Licensee of the Blue Cross and Blue Shield Association. GHSIC is a Medicare Advantage organization with a Medicare contract and a contract with the Oklahoma Medicaid program. Enrollment depends on contract renewal. https://www.bcbsok.com/legal-and-privacy/non-discrimination-notice`,
            },
        },
        tx: {
            logoName: 'hcsc-tx-logo.png',
            footer: {
                copyright: `Medicaid Plan Notice: Blue Cross and Blue Shield of Texas, a Division of Health Care Service Corporation, a Mutual Legal Reserve Company (HCSC), an Independent Licensee of the Blue Cross and Blue Shield Association.

Medicare Advantage Plan Notice: HMO Special Needs Plan provided by HCSC Insurance Services Company (HISC), an Independent Licensee of the Blue Cross and Blue Shield Association. HISC is a Medicare Advantage organization with a Medicare contract and a contract with the Texas Medicaid program. Enrollment in HISC's plan depends on contract renewal. https://www.bcbstx.com/legal-and-privacy/non-discrimination-notice`,
            },
        },
    },
}

export default config;
